import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=c97421ae&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=c97421ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97421ae",
  null
  
)

export default component.exports